import type { LiaUnread } from '../surfaces/LiaLauncher.js';

/**
 * LES REPONSES DE LIA QUI TOURNENT EN ARRIERE-PLAN. Une reponse vit dans
 * l'instance `ConversationLia` de son sujet (la requete, ses etapes, son
 * compteur) : changer de conversation ne doit pas la demonter, sinon la
 * requete est avortee. Le centre garde donc montes, en plus du sujet affiche,
 * tous les sujets dont la reponse est en cours ou pas encore vue, et chacun
 * dit son etat par `onEtat`. Fonctions pures, testees a part.
 */
export interface EtatLia { pending: boolean; unread: LiaUnread }
export type EtatsLia = ReadonlyMap<string, EtatLia>;

/** Un sujet au repos et vu n'a rien a garder : son entree disparait de la table. */
export function avecEtatLia(etats: EtatsLia, id: string, etat: EtatLia): EtatsLia {
  const avant = etats.get(id);
  const repos = !etat.pending && etat.unread === null;
  if (repos ? avant === undefined : avant?.pending === etat.pending && avant.unread === etat.unread) return etats;
  const suivants = new Map(etats);
  if (repos) suivants.delete(id); else suivants.set(id, etat);
  return suivants;
}

/**
 * Les sujets a garder montes : celui qu'on affiche (`actif`, null si le centre
 * est ferme ou sur une autre source) et ceux dont la reponse tourne ou attend
 * d'etre lue. Un sujet archive ou disparu n'est plus garde (le geste
 * « Supprimer » coupe sa reponse), sauf le sujet affiche. L'ORDRE est celui des
 * ids, jamais celui de la liste : un sujet qui remonte en tete ne deplace pas
 * son noeud dans la page.
 */
export function sujetsAMonter(sujets: readonly { id: string; archiveLe: number | null }[], actif: string | null, etats: EtatsLia): string[] {
  const gardes = new Set<string>();
  for (const sujet of sujets) {
    if (sujet.id === actif || (sujet.archiveLe === null && etats.has(sujet.id))) gardes.add(sujet.id);
  }
  return [...gardes].sort();
}

/** Ce que la mascotte montre : une reponse tourne quelque part, et la plus importante des non lues (l'erreur avant la reponse prete). */
export function etatAgregeLia(etats: EtatsLia): EtatLia {
  let pending = false;
  let unread: LiaUnread = null;
  for (const etat of etats.values()) {
    if (etat.pending) pending = true;
    if (etat.unread === 'error' || (etat.unread === 'ready' && unread === null)) unread = etat.unread;
  }
  return { pending, unread };
}
